import { render, staticRenderFns } from "./heavybag.vue?vue&type=template&id=c2639710&"
import script from "./heavybag.vue?vue&type=script&lang=js&"
export * from "./heavybag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports